export default __webpack_public_path__ + "static/media/navbar_icon_close.1f2e9678.svg";